const Footer = () => (
  <footer>
    © 2024 Jeshan Rai. Crafted with  React
  </footer>
);

export default Footer;
